import { vModelText as _vModelText, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22dd65c5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hide-desktop progressbar-wrapper" }
const _hoisted_2 = ["min", "max"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      type: "range",
      min: _ctx.min,
      max: _ctx.max,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
      style: _normalizeStyle({ backgroundImage: _ctx.getGradient() }),
      onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args))),
      onMousemove: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args))),
      onTouchmove: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args))),
      onTouched: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args))),
      onTouchstart: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args))),
      onTouchend: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onTouchend && _ctx.onTouchend(...args))),
      onInput: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onInput && _ctx.onInput(...args)))
    }, null, 44, _hoisted_2), [
      [_vModelText, _ctx.value]
    ])
  ]))
}